import { Table } from 'antd';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { DeleteActionButton } from 'routes/reading_groups/components/DeleteActionButton';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { GroupMetersTable as messages } from '../../messages';

type TableMeter = Pick<SerializedMeter, 'toolsId' | 'name'>;

interface GroupMetersTableProps {
  meters: TableMeter[];
  isLoading: boolean;
  onDeleteMeter: (meterId: number) => void;
}

export const GroupMetersTable: FC<GroupMetersTableProps> = ({ meters, isLoading, onDeleteMeter }) => {
  const intl = useIntl();

  const columns = [
    {
      title: <FormattedMessage {...messages.columnId} />,
      dataIndex: 'toolsId' satisfies keyof SerializedMeter,
      key: 'toolsId',
      render: (meterId: number) => <Link to={`/meter/${meterId}`}>{meterId}</Link>,
    },
    {
      title: <FormattedMessage {...messages.columnName} />,
      dataIndex: 'name' satisfies keyof SerializedMeter,
      key: 'name',
      width: 200,
    },
    {
      title: <FormattedMessage {...messages.columnActions} />,
      key: 'actions',
      render: (_: any, record: TableMeter) => (
        <DeleteActionButton
          confirmTitle={intl.formatMessage(messages.deleteConfirm)}
          id={parseInt(record.toolsId!)}
          isLoading={isLoading}
          label={intl.formatMessage(messages.delete)}
          onDelete={onDeleteMeter}
        />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={meters}
      loading={isLoading}
      pagination={{ pageSize: 10 }}
      rowKey="id"
      scroll={{ x: 'max-content' }}
      size="small"
    />
  );
};
